// extracted by mini-css-extract-plugin
module.exports = {"roomvuLogo":"VuSocialLogo_roomvuLogo__ab9z4","clickable":"VuSocialLogo_clickable__ybtWv"};